if(!customElements.get('plya-bundle-studio')){
  customElements.define('plya-bundle-studio',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.min=parseInt(this.dataset.min,10)||4;
      this.pct=parseFloat(this.dataset.pct)||0;
      this.free=parseInt(this.dataset.free,10)||0;
      this.$=(sel)=>this.querySelector(sel);
      this.items=[...this.querySelectorAll('[data-bs-item]')].map(el=>{
        const prods=[...el.querySelectorAll('[data-bs-prod]')].map(pe=>({el:pe,variants:JSON.parse(pe.querySelector('[data-bs-variants]').textContent),fields:[...pe.querySelectorAll('[data-bs-option]')],img:pe.dataset.img||null,title:pe.dataset.title,touched:false}));
        return {el,prods,key:el.dataset.key||'other',qty:el.querySelector('[data-bs-qty]'),img:el.querySelector('[data-bs-img]'),line:el.querySelector('[data-bs-line]'),qb:el.querySelector('[data-bs-qb]'),audience:el.dataset.audience};
      });
      this.items.forEach(it=>{
        it.prods.forEach(pr=>pr.fields.forEach(f=>f.addEventListener('change',()=>{pr.touched=true;this.update();})));
        it.el.querySelectorAll('[data-bs-type]').forEach(r=>r.addEventListener('change',()=>{this.showType(it);this.update();}));
        it.el.querySelector('[data-bs-minus]').addEventListener('click',()=>this.setQty(it,this.q(it)-1));
        it.el.querySelector('[data-bs-plus]').addEventListener('click',()=>this.setQty(it,this.q(it)+1));
        it.qty.addEventListener('change',()=>this.setQty(it,parseInt(it.qty.value,10)));
      });
      this.querySelectorAll('.bs-aud').forEach(r=>r.addEventListener('change',()=>{this.clearPicked();this.update();}));
      this.querySelectorAll('[data-bs-add]').forEach(b=>b.addEventListener('click',()=>this.add()));
      this.querySelectorAll('[data-bs-preset]').forEach(b=>b.addEventListener('click',()=>this.usePreset(b)));
      const start=this.$('[data-bs-start]');
      if(start)start.addEventListener('click',()=>this.scrollTo(this.$('[data-bs-presets]')||this.$('[data-bs-build]')));
      const tb=this.$('[data-bs-tipbtn]');
      tb.addEventListener('click',()=>{const it=this.tipItem;if(it){this.setQty(it,this.q(it)+1);this.toast(this.added(it));}});
      const ticks=this.$('[data-bs-ticks]');for(let i=1;i<this.min;i++)ticks.appendChild(document.createElement('em'));
      try{const u=new URL(window.location.href);if(u.searchParams.get('for')==='kids'){const k=this.querySelector('.bs-aud[value="kids"]');if(k)k.checked=true;}}catch(e){}
      this.fan();
      this.update();
      this.watchBar();
    }
    q(it){return parseInt(it.qty.value,10)||0;}
    setQty(it,v){if(isNaN(v)||v<0)v=0;if(v>20)v=20;const was=this.q(it);it.qty.value=v;this.clearPicked();this.update();if(v>was)this.bump(it);}
    bump(it){it.el.classList.remove('is-bump');void it.el.offsetWidth;it.el.classList.add('is-bump');}
    showType(it){const a=this.active(it);it.prods.forEach((pr,i)=>pr.el.hidden=i!==a);}
    scrollTo(el){if(!el)return;const y=el.getBoundingClientRect().top+window.scrollY-90;window.scrollTo({top:y,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
    fan(){
      const fan=this.$('[data-bs-fan]');if(!fan)return;
      const seen=new Set();
      this.items.filter(it=>it.audience!=='kids').forEach(it=>{if(seen.has(it.key)||seen.size>=4)return;const src=it.prods[0].img;if(!src)return;seen.add(it.key);const sp=document.createElement('span');const im=new Image();im.src=src;im.alt='';im.loading='eager';sp.appendChild(im);fan.appendChild(sp);});
    }
    money(cents){
      let fmt=this.dataset.money||'';if(!/\{\{/.test(fmt))fmt='£'+String.fromCharCode(123,123)+'amount'+String.fromCharCode(125,125);
      const v=(cents/100);const two=v.toFixed(2);
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,(m,k)=>{
        if(k==='amount_no_decimals')return Math.round(v).toLocaleString('en-GB');
        if(k==='amount_with_comma_separator')return two.replace('.',',');
        return Number(two).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});
      });
    }
    audience(){const r=this.querySelector('.bs-aud:checked');return r?r.value:'adults';}
    visible(it){const a=this.audience();return it.audience==='both'||it.audience===a;}
    active(it){const r=it.el.querySelector('[data-bs-type]:checked');return r?parseInt(r.value,10)||0:0;}
    variantFor(pr){
      if(!pr.fields.length)return pr.variants[0];
      const opts=[];
      pr.fields.forEach(f=>{const c=f.querySelector('input:checked');opts[+f.dataset.bsOption]=c?c.value:null;});
      return pr.variants.find(v=>v.options.every((o,i)=>o===opts[i]));
    }
    presetVariant(pr,opt){
      const cur=this.variantFor(pr);
      if(!opt)return (cur&&cur.available)?cur:this.firstAvail(pr);
      const hit=pr.variants.filter(v=>v.options.some(o=>String(o).toLowerCase().includes(opt)));
      if(!hit.length)return cur||this.firstAvail(pr);
      const same=cur?hit.find(v=>v.available&&v.options.every((o,i)=>String(o).toLowerCase().includes(opt)||o===cur.options[i])):null;
      return same||hit.find(v=>v.available)||hit[0];
    }
    applyVariant(pr,v){
      if(!v)return;
      pr.fields.forEach(f=>{const val=v.options[+f.dataset.bsOption];f.querySelectorAll('input').forEach(i=>{if(i.value===val)i.checked=true;});});
    }
    firstAvail(pr){return pr.variants.find(v=>v.available)||pr.variants[0];}
    escape(t){const d=document.createElement('div');d.textContent=t;return d.innerHTML;}
    parsePreset(str){
      return (str||'').split(/[,\n]/).map(x=>x.trim()).filter(Boolean).map(x=>{const m=x.match(/^([a-z]+)\s*=\s*(\d+)(?:\s*@\s*(\d))?(?:\s*\/\s*(.+))?$/i);return m?{key:m[1].toLowerCase(),qty:parseInt(m[2],10),type:m[3]?parseInt(m[3],10)-1:0,opt:m[4]?m[4].trim().toLowerCase():''}:null;}).filter(Boolean);
    }
    itemFor(key){return this.items.find(it=>it.key===key&&this.visible(it));}
    presetPrice(str){
      let total=0,count=0;const pics=[];
      this.parsePreset(str).forEach(p=>{const it=this.itemFor(p.key);if(!it)return;const pr=it.prods[p.type]||it.prods[0];const v=this.presetVariant(pr,p.opt);if(!v)return;total+=v.price*p.qty;count+=p.qty;if(pr.img)pics.push(pr.img);});
      const disc=(count>=this.min&&this.pct>0)?Math.round(total*this.pct/100):0;
      return {total,count,disc,pics};
    }
    paintPresets(){
      this.querySelectorAll('[data-bs-preset]').forEach(b=>{
        const r=this.presetPrice(b.dataset.bsPreset);
        b.querySelector('[data-bs-pwas]').textContent=r.disc?this.money(r.total):'';
        b.querySelector('[data-bs-pnow]').textContent=this.money(r.total-r.disc);
        const fr=this.free>0&&(r.total-r.disc)>=this.free;b.querySelector('[data-bs-psave]').textContent=(r.disc?('You save '+this.money(r.disc)+' · '):'')+r.count+' items'+(fr?' · Free delivery':'');
        const th=b.querySelector('[data-bs-pthumbs]');const key=r.pics.join('|');
        if(th.dataset.k!==key){th.dataset.k=key;th.innerHTML='';r.pics.slice(0,5).forEach(src=>{const im=new Image();im.src=src;im.alt='';im.loading='lazy';th.appendChild(im);});}
      });
    }
    clearPicked(){this.querySelectorAll('.bs-preset.is-picked').forEach(b=>b.classList.remove('is-picked'));}
    usePreset(btn){
      const list=this.parsePreset(btn.dataset.bsPreset);
      this.items.forEach(it=>{if(this.visible(it))it.qty.value=0;});
      list.forEach(p=>{const it=this.itemFor(p.key);if(!it)return;const r=it.el.querySelector('[data-bs-type][value="'+p.type+'"]');if(r){r.checked=true;this.showType(it);}const pr=it.prods[this.active(it)]||it.prods[0];if(p.opt)this.applyVariant(pr,this.presetVariant(pr,p.opt));it.qty.value=Math.min(20,this.q(it)+p.qty);this.bump(it);});
      this.update();
      this.clearPicked();btn.classList.add('is-picked');
      const name=(btn.querySelector('.bs-pname')||{}).textContent||'';
      this.toast(name.trim()+' added to your bundle. Change anything below.');
      this.scrollTo(this.$('[data-bs-build]'));
    }
    added(it){const pr=it.prods[this.active(it)]||it.prods[0];return pr.title+' added';}
    toast(t){const el=this.$('[data-bs-toast]');if(!el)return;el.textContent=t;el.classList.add('is-show');clearTimeout(this.tt);this.tt=setTimeout(()=>el.classList.remove('is-show'),2600);}
    animate(el,to){
      if(!el)return;const from=el._v==null?to:el._v;el._v=to;
      if(from===to||matchMedia('(prefers-reduced-motion: reduce)').matches){el.textContent=this.money(to);return;}
      const t0=performance.now(),d=450;cancelAnimationFrame(el._raf);
      const step=(t)=>{const k=Math.min(1,(t-t0)/d);const e=1-Math.pow(1-k,3);el.textContent=this.money(Math.round(from+(to-from)*e));if(k<1)el._raf=requestAnimationFrame(step);};
      el._raf=requestAnimationFrame(step);
    }
    update(){
      let count=0,total=0;const chosen=[];const keys={};
      this.items.forEach(it=>{
        const vis=this.visible(it);
        const pr=it.prods[this.active(it)]||it.prods[0];
        it.title=pr.title;
        const v=this.variantFor(pr);
        const q=this.q(it);
        const want=(pr.touched&&v&&v.image)?v.image:pr.img;
        if(it.img&&want&&it.shown!==want){it.img.removeAttribute('srcset');it.img.src=want;it.shown=want;}
        it.pic=want;
        const on=vis&&v&&v.available&&q>0;
        it.el.classList.toggle('is-on',!!on);
        if(it.qb)it.qb.textContent='×'+q;
        it.chosen=on?{id:v.id,quantity:q}:null;
        if(on){count+=q;total+=v.price*q;chosen.push({it,v,q});if(!keys[it.key])keys[it.key]=want;}
        it.unit=v?v.price:0;it.available=!!(v&&v.available);it.q=q;it.vis=vis;
      });
      const unlocked=count>=this.min&&this.pct>0;
      const disc=unlocked?Math.round(total*this.pct/100):0;
      const pay=total-disc;
      this.items.forEach(it=>{
        if(!it.line)return;
        if(!it.available){it.line.textContent='Sold out';return;}
        const line=it.unit*Math.max(it.q,1);
        if(unlocked&&it.q>0)it.line.innerHTML='<s>'+this.money(line)+'</s><b>'+this.money(Math.round(line*(100-this.pct)/100))+'</b>';
        else it.line.textContent=this.money(line);
      });
      // kit checklist
      let have=0;
      this.querySelectorAll('[data-bs-slot]').forEach(sl=>{
        const k=sl.dataset.bsSlot;const src=keys[k];const box=sl.querySelector('.bs-slot-pic');
        sl.classList.toggle('is-on',!!src);
        if(src){have++;let im=box.querySelector('img');if(!im){im=new Image();im.alt='';box.appendChild(im);}if(im.dataset.s!==src){im.src=src;im.dataset.s=src;}}
      });
      const kitmsg=this.$('[data-bs-kitmsg]');
      kitmsg.innerHTML=have>=4?'<b>✓ Full matchday kit.</b> Socks, shin pads, sleeves and tape.':(have?('Full kit: '+have+' of 4 parts'):'Socks, shin pads, sleeves and tape make a full kit.');
      // list
      const list=this.$('[data-bs-list]');list.innerHTML='';
      if(!chosen.length){const li=document.createElement('li');li.className='bs-empty';li.textContent='Choose your items';list.appendChild(li);}
      chosen.forEach(({it,v,q})=>{const li=document.createElement('li');const opts=v.options.filter(o=>o&&o!=='Default Title'&&o!=='A').join(' · ');li.innerHTML='<span>'+this.escape(it.title)+' × '+q+(opts?'<small>'+this.escape(opts)+'</small>':'')+'</span><span>'+this.money(v.price*q)+'</span>';list.appendChild(li);});
      // numbers
      const left=Math.max(0,this.min-count);
      const countTxt=count===1?'1 item':count+' items';
      this.$('[data-bs-count]').textContent=countTxt;
      this.$('[data-bs-bar]').style.width=Math.min(100,count/this.min*100)+'%';
      this.$('[data-bs-progress]').textContent=Math.min(count,this.min)+' / '+this.min;
      const status=unlocked?(this.pct+'% off unlocked'):('Add '+left+' more for '+this.pct+'% off');
      this.$('[data-bs-status]').textContent=status;
      this.$('[data-bs-sub]').textContent=this.money(total);
      this.$('[data-bs-discrow]').hidden=!unlocked;
      this.$('[data-bs-disc]').textContent='−'+this.money(disc);
      const freeShip=this.free>0&&pay>=this.free;
      this.$('[data-bs-ship]').textContent=!count?'–':(freeShip?'FREE':((this.dataset.ship||'')+' or free over '+this.money(this.free)));
      this.$('[data-bs-was]').textContent=unlocked?this.money(total):'';
      this.animate(this.$('[data-bs-now]'),pay);
      const save=this.$('[data-bs-save]');
      const wasUnlocked=this.unlocked;this.unlocked=unlocked;
      save.hidden=!unlocked;
      if(unlocked){save.textContent='✓ You save '+this.money(disc)+' ('+this.pct+'%) on this bundle';if(!wasUnlocked&&wasUnlocked!==undefined){save.classList.remove('is-pop');void save.offsetWidth;save.classList.add('is-pop');this.toast(this.pct+'% off unlocked. You save '+this.money(disc)+'!');}}
      this.querySelectorAll('[data-bs-add]').forEach(b=>b.disabled=!chosen.length);
      // smart tip
      this.tip(count,left,unlocked,pay,keys);
      // mobile bar
      const mset=(sel,t)=>{const e=this.$(sel);if(e)e.textContent=t;};
      mset('[data-bs-mcount]',countTxt);
      mset('[data-bs-mstatus]',unlocked?(freeShip?this.pct+'% off + free delivery':this.pct+'% off unlocked'):status);
      mset('[data-bs-mwas]',unlocked?this.money(total):'');
      this.animate(this.$('[data-bs-mnow]'),pay);
      const ml=this.$('[data-bs-mbarline]');if(ml)ml.style.width=Math.min(100,count/this.min*100)+'%';
      this.paintPresets();
    }
    tip(count,left,unlocked,pay,keys){
      const box=this.$('[data-bs-tip]'),txt=this.$('[data-bs-tiptext]'),btn=this.$('[data-bs-tipbtn]');
      const cand=this.items.filter(it=>it.vis&&it.available);
      const price=(it)=>it.unit;
      let pick=null,msg='';
      if(!count){
        msg='Pick any <b>'+this.min+' items</b> and the whole bundle is <b>'+this.pct+'% off</b>. Or start from a ready-made bundle above.';
      }else if(!unlocked){
        const missing=cand.filter(it=>!keys[it.key]&&['socks','shin','sleeves','tape'].includes(it.key));
        const pool=missing.length?missing:cand;
        pick=pool.slice().sort((a,b)=>price(a)-price(b))[0]||null;
        msg='Add <b>'+left+' more '+(left===1?'item':'items')+'</b> to save <b>'+this.pct+'%</b> on everything.';
      }else if(this.free>0&&pay<this.free){
        const gap=this.free-pay;
        const net=(it)=>Math.round(it.unit*(100-this.pct)/100);
        const enough=cand.filter(it=>net(it)>=gap).sort((a,b)=>net(a)-net(b));
        pick=enough[0]||cand.slice().sort((a,b)=>net(b)-net(a))[0]||null;
        msg='You are <b>'+this.money(gap)+'</b> away from <b>free UK delivery</b>.';
      }else{
        msg='<b>Best deal.</b> '+this.pct+'% off'+(this.free>0?' and free UK delivery':'')+' on this bundle.';
      }
      box.hidden=false;txt.innerHTML=msg;
      this.tipItem=pick;
      if(pick){const pr=pick.prods[this.active(pick)]||pick.prods[0];const after=unlocked||count+1>=this.min?Math.round(pick.unit*(100-this.pct)/100):pick.unit;btn.hidden=false;btn.textContent='+ Add '+pr.title+' · '+this.money(after);}
      else btn.hidden=true;
    }
    watchBar(){
      const bar=this.$('[data-bs-mbar]');const sum=this.$('.bs-sum');const top=this.$('[data-bs-build]');
      if(!bar||!('IntersectionObserver' in window))return;
      let sumIn=false,started=false;
      const set=()=>bar.classList.toggle('is-hidden',sumIn||!started);
      new IntersectionObserver(es=>es.forEach(e=>{sumIn=e.isIntersecting;set();}),{threshold:.25}).observe(sum);
      new IntersectionObserver(es=>es.forEach(e=>{started=e.isIntersecting||e.boundingClientRect.top<0;set();}),{threshold:0}).observe(top);
      set();
    }
    async add(){
      const btns=[...this.querySelectorAll('[data-bs-add]')];
      const txts=[...this.querySelectorAll('[data-bs-btn-text]')];
      const msgs=[...this.querySelectorAll('[data-bs-msg]')];
      const items=this.items.filter(it=>it.chosen).map(it=>it.chosen);
      if(!items.length)return;
      const labels=txts.map(t=>t.textContent);
      btns.forEach(b=>b.disabled=true);
      txts.forEach(t=>t.textContent='Adding…');
      try{
        const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        const res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        if(!res.ok)throw new Error('add failed');
        window.location.href=root+'cart';
      }catch(e){
        btns.forEach(b=>b.disabled=false);
        txts.forEach((t,i)=>t.textContent=labels[i]);
        msgs.forEach(m=>m.textContent='Sorry, something went wrong. Please try again.');
      }
    }
  });
}
